var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8781L5.77251 15.1058C5.65709 15.2211 5.51202 15.2802 5.3373 15.2829C5.16272 15.2856 5.01501 15.2265 4.89418 15.1058C4.77348 14.985 4.71313 14.8386 4.71313 14.6667C4.71313 14.4947 4.77348 14.3483 4.89418 14.2275L9.12189 10L4.89418 5.77251C4.7789 5.65709 4.71987 5.51202 4.71709 5.3373C4.71445 5.16272 4.77348 5.01501 4.89418 4.89418C5.01501 4.77348 5.1614 4.71313 5.33334 4.71313C5.50529 4.71313 5.65168 4.77348 5.77251 4.89418L10 9.12189L14.2275 4.89418C14.3429 4.7789 14.488 4.71987 14.6627 4.71709C14.8373 4.71445 14.985 4.77348 15.1058 4.89418C15.2265 5.01501 15.2869 5.1614 15.2869 5.33334C15.2869 5.50529 15.2265 5.65168 15.1058 5.77251L10.8781 10L15.1058 14.2275C15.2211 14.3429 15.2802 14.488 15.2829 14.6627C15.2856 14.8373 15.2265 14.985 15.1058 15.1058C14.985 15.2265 14.8386 15.2869 14.6667 15.2869C14.4947 15.2869 14.3483 15.2265 14.2275 15.1058L10 10.8781Z",
    fill: "#666668"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.99582a1de5db72fd8e3b637e9cefb49e.svg";
export { ForwardRef as ReactComponent };